import React, { useState, useEffect } from "react";

const Clock = ({ timezone, label }) => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Calcular ángulos de las manecillas
  const getTimeInTimezone = () => {
    const options = { timeZone: timezone, hour12: false };
    const timeString = time.toLocaleTimeString("en-US", options);
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    return { hours, minutes, seconds };
  };

  const { hours, minutes, seconds } = getTimeInTimezone();

  // Ángulo de la manecilla de horas (30° por hora + 0.5° por minuto)
  const hourAngle = (hours % 12) * 30 + minutes * 0.5;

  // Ángulo de la manecilla de minutos (6° por minuto + 0.1° por segundo)
  const minuteAngle = minutes * 6 + seconds * 0.1;

  // Formato de hora digital
  const displayTime = time.toLocaleTimeString("en-US", {
    timeZone: timezone,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return (
    <div className="text-center">
      <div className="w-12 h-12 rounded-full border border-black dark:border-white relative mx-auto mb-2">
        {/* Manecilla de horas */}
        <div
          className="absolute w-[1px] h-5 bg-black dark:bg-white left-1/2 top-1 origin-bottom transition-transform duration-1000"
          style={{ transform: `rotate(${hourAngle}deg)` }}
        ></div>
        {/* Manecilla de minutos */}
        <div
          className="absolute w-[1px] h-4 bg-black dark:bg-white left-1/2 top-2 origin-bottom transition-transform duration-1000"
          style={{ transform: `rotate(${minuteAngle}deg)` }}
        ></div>
        {/* Centro del reloj */}
        <div className="absolute w-1 h-1 bg-black dark:bg-white rounded-full left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"></div>
      </div>
      <p className="font-mono text-[10px] uppercase font-bold">{label}</p>
      <p className="font-mono text-[10px] text-gray-500">{displayTime}</p>
    </div>
  );
};

export const Footer = () => {
  return (
    <footer className="pt-20 border-t border-black dark:border-white px-4 md:px-12 lg:px-24 max-w-8xl mx-auto pb-8">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-12">
        <div className="flex gap-8">
          <Clock timezone="America/Mexico_City" label="CDMX" />
          <Clock timezone="America/New_York" label="MIA" />
        </div>
        <div className="space-y-4">
          <div>
            <p className="font-mono text-[10px] uppercase font-bold mb-1">
              Contacto
            </p>
            <a
              className="font-display text-lg hover:italic"
              href="mailto:hello@antagonista.ai"
            >
              hello@antagonista.io
            </a>
          </div>
          {/* 
          <div>
            <p className="font-mono text-[10px] uppercase font-bold mb-1">
              Careers
            </p>
            <a
              className="font-display text-lg hover:italic"
              href="mailto:jobs@antagonista.io"
            >
              jobs@antagonista.io
            </a>
          </div> */}
        </div>
        <div className="text-right">
          <p className="font-mono text-[10px] uppercase tracking-widest mb-1">
            © 2026 Antagonista - Casa Creativa. Todos los derechos reservados.
          </p>
          <div className="flex justify-end gap-1">
            <div className="w-1 h-4 bg-black dark:bg-white"></div>
            <div className="w-1 h-4 bg-black dark:bg-white"></div>
            <div className="w-1 h-4 bg-black dark:bg-white"></div>
          </div>
        </div>
      </div>
    </footer>
  );
};
